module.exports = __webpack_public_path__ + "img/stamp.8bc34aec.png";